import BuefyMixin from "@/mixins/BuefyMixin";
import CustomErrorMixin from "@/mixins/CustomError";

export default [BuefyMixin, CustomErrorMixin];
